export var DFURequestStatus;
(function (DFURequestStatus) {
    DFURequestStatus["Pending"] = "PENDING";
    DFURequestStatus["Started"] = "STARTED";
    DFURequestStatus["Complete"] = "COMPLETE";
    DFURequestStatus["Failed"] = "FAILED";
})(DFURequestStatus || (DFURequestStatus = {}));
//# sourceMappingURL=dfu.js.map